import type { CSSProperties, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import type { RgbString } from '@sorare/core/src/lib/colors';
import type { unitMapping } from '@sorare/core/src/lib/style.ts';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';
import type { RGBColor } from '@sorare/core/src/style/types';

const Root = styled(Vertical)`
  max-width: 100%;
  width: 100%;
  position: relative;
  padding: var(--unit);
  border-radius: var(--double-unit);
  border: 1px solid transparent;
  box-shadow: inset 0px 50px 50px -50px rgba(var(--rgb-color), 0.08);
  background:
    radial-gradient(
        50% 4px at 50% 0%,
        rgba(var(--rgb-color), 1) 0%,
        transparent 100%
      )
      no-repeat,
    radial-gradient(
        50% 30px at 50% 0%,
        rgba(var(--rgb-color), 0.3) 0%,
        transparent 100%
      )
      no-repeat,
    linear-gradient(to bottom, var(--c-nl-500), var(--c-black)) padding-box,
    conic-gradient(from 90deg at 4px 4px, var(--c-nd-50) 25%, var(--c-black) 0)
      0 0/5px 5px padding-box,
    linear-gradient(
        to bottom,
        rgba(var(--rgb-color), 0.08),
        rgba(var(--rgb-color), 0)
      )
      border-box;

  @media ${tabletAndAbove} {
    padding: var(--double-unit);
  }
`;

type Props = PropsWithChildren<{
  rgbColor: RgbString | RGBColor;
  gap?: keyof typeof unitMapping;
  className?: string;
}>;

export const LineupsGroup = ({
  rgbColor,
  gap = 2,
  className,
  children,
}: Props) => (
  <Root
    gap={gap}
    className={className}
    style={{ '--rgb-color': rgbColor } as CSSProperties}
  >
    {children}
  </Root>
);
